import { Column, flexRender, Table } from '@tanstack/react-table';
import { ColumnHeaderLabelContext } from '../data-table/column-header-label-context';

/** A column's header as a plain label: its `DataTableColumnHeader` title without the sort and
 * filter controls (a plain header function renders as it is). */
export const ColumnLabel = <TData,>({
  table,
  column,
}: {
  table: Table<TData>;
  column: Column<TData, unknown>;
}) => {
  const header = table.getLeafHeaders().find((leaf) => leaf.column.id === column.id);
  if (!header || header.isPlaceholder) return null;
  return (
    <ColumnHeaderLabelContext.Provider value>
      {flexRender(column.columnDef.header, header.getContext())}
    </ColumnHeaderLabelContext.Provider>
  );
};
